import { render, staticRenderFns } from "./withdrawInfo.vue?vue&type=template&id=6b7261d7&scoped=true&"
import script from "./withdrawInfo.vue?vue&type=script&lang=js&"
export * from "./withdrawInfo.vue?vue&type=script&lang=js&"
import style0 from "./withdrawInfo.vue?vue&type=style&index=0&id=6b7261d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7261d7",
  null
  
)

export default component.exports